import { Select, MenuItem, FormControl, InputBase } from "@mui/material";
import { styled } from "@mui/material/styles";

// --- Styled Components ---

const StyledFormControl = styled(FormControl)({
  // Override any accessibility or global styles
  "&.custom-select-control": {
    minHeight: "30px !important",
    height: "30px !important",
    "& .MuiInputBase-root": {
      minHeight: "30px !important",
      height: "30px !important",
    },
    "& .MuiSelect-select": {
      minHeight: "30px !important",
      height: "30px !important",
      lineHeight: "18px !important",
      paddingTop: "6px !important",
      paddingBottom: "6px !important",
    },
  },
});

const StyledInput = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input": {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    height: "30px !important",
    minHeight: "30px !important",
    maxHeight: "30px !important",
    width: "109px",
    boxSizing: "border-box",
    padding: "6px 16px",
    borderRadius: "4px",
    border: "1px solid #003A5D",
    background: "#EEF3F7",
    color: "#003A5D", // Color for the placeholder text in closed state
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "18px !important",
    // Ensure the text truncates cleanly if it gets too long
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    "&:focus": {
      borderRadius: "4px",
      borderColor: "#003A5D",
    },
  },
}));

// Custom Arrow Icon matching your exact dimensions and stroke
const DropdownIcon = (props) => (
  <svg
    {...props}
    width="12"
    height="16"
    viewBox="0 0 7 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      pointerEvents: "none",
      position: "absolute",
      right: 12,
    }}
  >
    <path
      d="M1 1L3.5 3L6 1"
      stroke="rgba(0, 58, 93, 0.80)"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// --- Main Export ---

export default function CustomSelect({ value, onChange, options = [] }) {
  return (
    <StyledFormControl variant="standard" className="custom-select-control">
      <Select
        value={value}
        onChange={onChange}
        input={<StyledInput />}
        IconComponent={DropdownIcon}
        renderValue={(selected) => {
          // This ensures the label (e.g., "All Events") shows up, not the value ("all")
          const selectedOption = options.find((opt) => opt.value === selected);
          return selectedOption ? selectedOption.label : "";
        }}
        MenuProps={{
          autoFocus: false,
          disableScrollLock: true,
          PaperProps: {
            sx: {
              borderRadius: "4px",
              marginTop: "4px",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              border: "1px solid #DEDEDE",
              // Targeting and styling the selected menu item
              "& .MuiMenuItem-root.Mui-selected": {
                backgroundColor: "transparent", // Remove selected highlight background
                color: "#003A5D", // Change text color to the specified highlighted color
              },
            },
          },
        }}
      >
        {options.map((opt) => (
          <MenuItem
            key={opt.value}
            value={opt.value}
            sx={{
              fontSize: "12px",
              color: "#141414", // Text color for unselected items (Black)
              fontFamily: "Inter, sans-serif",
              fontWeight: 500,
              // --- Add these lines to reduce space ---
              minHeight: "unset", // Removes the default MUI minimum height
              paddingTop: "4px", // Adjust this value to your liking
              paddingBottom: "4px", // Adjust this value to your liking
              // ---------------------------------------
              "&:hover": {
                backgroundColor: "rgba(0, 58, 93, 0.08)", // Keep a subtle hover background
              },
            }}
          >
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </StyledFormControl>
  );
}
